import { VueConstructor } from 'vue';
import { CoreOptions } from '../../index';
import Translator from './translator';
import Formatter from './formatter';
import dateFactory from './date';

declare module 'vue/types/vue' {
  interface Vue {
    $date: ReturnType<typeof dateFactory>;
    $translation: Translator;
    $t: InstanceType<typeof Translator>['translate'];
    $tAlt: InstanceType<typeof Translator>['translateAlternative'];
    $tEnum: InstanceType<typeof Translator>['translateEnum'];
    $format: InstanceType<typeof Formatter>;
  }
  interface VueConstructor {
    $date: ReturnType<typeof dateFactory>;
    $translation: Translator;
    $t: InstanceType<typeof Translator>['translate'];
    $tAlt: InstanceType<typeof Translator>['translateAlternative'];
    $tEnum: InstanceType<typeof Translator>['translateEnum'];
    $format: InstanceType<typeof Formatter>;
  }
}

export default {
  install: (Vue: VueConstructor, options: CoreOptions) => {
    // TODO: make locale configurable
    const localeCode = 'de-ch';
    // Initalize first since the classes below are dependent on this
    Vue.$date = dateFactory(localeCode);
    Vue.prototype.$date = Vue.$date;

    const translation = new Translator(options.translations);
    const formatter = new Formatter(localeCode);
    Vue.$translation = translation;
    Vue.$t = translation.translate.bind(translation);
    Vue.$tAlt = translation.translateAlternative.bind(translation);
    Vue.$tEnum = translation.translateEnum.bind(translation);
    Vue.$format = formatter;
    Vue.prototype.$translation = Vue.$translation;
    Vue.prototype.$t = Vue.$t;
    Vue.prototype.$tAlt = Vue.$tAlt;
    Vue.prototype.$tEnum = Vue.$tEnum;
    Vue.prototype.$format = Vue.$format;
  },
};
